import { useState, useEffect } from 'react'
import { NormalButton } from '@!/components/Button'
import { CircularProgressModal, YesNoPopupModal, ConfirmPopupModal } from '@!/components/Modal'
import { useReadBook } from '@!/Hooks'

export const SampleButton = ({ contentId, sampleBookId, sampleFilePath, adultFlag, price, isPurchased }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [readCotentSampleMutation, redirectUrl, apiError, setApiError] = useReadBook('sample')

  useEffect(() => {
    if (!redirectUrl) return

    window.location.href = redirectUrl
  }, [redirectUrl])

  const executeAction = async () => {
    readCotentSampleMutation.mutate({ contentId: contentId })
  }

  const handleButtonAction = (event) => {
    event.preventDefault()

    // 作品のadultFlagが3(hard)以上の場合、性的・暴力的表現の警告を表示する
    if (adultFlag >= 3) {
      setModalOpen(true)
    } else {
      executeAction()
    }
  }

  const handleCancelDialog = () => {
    setModalOpen(false)
  }

  const handleWarningSubmit = () => {
    setModalOpen(false)
    executeAction()
  }

  const handleApiError = () => {
    console.log(apiError)
    setApiError(null)
  }

  return (
    <>
      <NormalButton
        isDisabled={!sampleBookId || !sampleFilePath || price === 0 || isPurchased}
        onClick={(event) => handleButtonAction(event)}
        width="100%"
        height="37px"
      >
        無料立ち読み
      </NormalButton>
      <YesNoPopupModal
        title="この作品には性的・暴力的な表現が一部含まれている可能性があります。ご了承の上閲覧しますか?"
        handleCancel={() => handleCancelDialog()}
        handleSubmit={() => handleWarningSubmit()}
        cancelTitle="キャンセル"
        submitTitle="はい"
        isOpen={modalOpen}
      />
      <ConfirmPopupModal text="エラーが発生しました。" handlePopup={() => handleApiError()} isOpen={!!apiError} />
      <CircularProgressModal isOpen={readCotentSampleMutation.isPending} />
    </>
  )
}
